"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var hooks_1 = require("./hooks");

exports.IntersectionObserver = react_1.default.memo(function IntersectionObserver(_a) {
  var children = _a.children,
      root = _a.root,
      rootMargin = _a.rootMargin,
      threshold = _a.threshold,
      unsupportedBehavior = _a.unsupportedBehavior,
      _b = _a.wrapperComponent,
      Wrapper = _b === void 0 ? 'div' : _b,
      onIntersectionChange = _a.onIntersectionChange;

  var _c = tslib_1.__read(hooks_1.useIntersection({
    root: root,
    rootMargin: rootMargin,
    threshold: threshold,
    unsupportedBehavior: unsupportedBehavior
  }), 2),
      intersection = _c[0],
      ref = _c[1];

  hooks_1.useValueTracking(intersection, function (newValue) {
    return onIntersectionChange(newValue);
  });
  return react_1.default.createElement(Wrapper, {
    ref: ref
  }, children);
});